import {
    ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS,
    FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS,
    FETCH_PROJECT_COST_PRIORITY_SUCCESS,
    FILTER_PROJECT_COST_PRIORITY,
    GET_ALL_PROJECT_COST_PRIORITY,
    GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY,
    HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE,
    HIDE_PROJECT_COST_PRIORITY_LOADER,
    SHOW_PROJECT_COST_PRIORITY_LOADER,
    ON_ADD_PROJECT_COST_PRIORITY,
    ON_EDIT_PROJECT_COST_PRIORITY,
    ON_ALL_PROJECT_COST_PRIORITY_SELECT,
    ON_PROJECT_COST_PRIORITY_CLOSE,
    ON_PROJECT_COST_PRIORITY_SELECT,
    ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS,
    ON_FILTER_SELECTED_PROJECT_COST_PRIORITY,
    ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT,
    ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS,
    ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER,
    SHOW_PROJECT_COST_PRIORITY_MESSAGE,
    UPDATE_SEARCH_PROJECT_COST_PRIORITY,
    CLEAR_SESSION,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All priorities';
export const STARRED_FILTER = 'Starred priorities';
export const SUCCESSFUL_UPDATE = 'Priorities Updated Successfully';
export const SUCCESSFUL_FILTER = 'Priorities Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Priorities Deleted Successfully';
export const REMOVED_AS_STAR = 'Priorities removed as star';
export const MARKED_AS_STAR = 'Priorities marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No priorities found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allProjectCostPriority: [],
    projectCostPriorityList: [],
    selectedProjectCostPriority: null,
    selectedProjectCostPrioritys: 0,
    addProjectCostPriorityState: false,
    editProjectCostPriorityState: false,
    searchProjectCostPriority: '',
    projectCostPriority: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedProjectCostPriority: null,
            };
        }
        case ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS: {
            const allUpdated = state.allProjectCostPriority.map((entry) => entry?.id === action?.payload?.id ? {
                ...entry,
                starred: !action?.payload?.starred
            } : entry);
            let listUpdated = {};
            switch (state.filterOption) {
                case ALL_FILTER: {
                    listUpdated = allUpdated;
                    break;
                }
                case STARRED_FILTER: {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
                showMessage: true,
                projectCostPriorityList: listUpdated,
                allProjectCostPriority: allUpdated,
            };
        }
        case FETCH_PROJECT_COST_PRIORITY_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedProjectCostPriority: action.payload,
                addProjectCostPriorityState: false,
                editProjectCostPriorityState: false,
            };
        }
        case FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS: {
            return {
                ...state,
                loader: false,
                allProjectCostPriority: action.payload,
                projectCostPriorityList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
                addProjectCostPriorityState: false,
                editProjectCostPriorityState: false,
            };
        }
        case SHOW_PROJECT_COST_PRIORITY_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_PROJECT_COST_PRIORITY_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedProjectCostPrioritys = 0;
            const projectCostPriorityList = state.projectCostPriorityList.map(projectCostPriority => {
                if (projectCostPriority.selected) {
                    selectedProjectCostPrioritys++;
                }
                if (projectCostPriority.id === action.payload.id) {
                    if (projectCostPriority.selected) {
                        selectedProjectCostPrioritys++;
                    }
                    return action.payload;
                } else {
                    return projectCostPriority;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedProjectCostPrioritys: selectedProjectCostPrioritys,
                projectCostPriorityList: projectCostPriorityList
            };
        }
        case ON_ADD_PROJECT_COST_PRIORITY: {
            return {
                ...state,
                addProjectCostPriorityState: true,
                editProjectCostPriorityState: false,
            };
        }
        case ON_EDIT_PROJECT_COST_PRIORITY: {
            return {
                ...state,
                selectedProjectCostPriority: action.payload,
                editProjectCostPriorityState: true,
                addProjectCostPriorityState: false,
            };
        }
        case ON_PROJECT_COST_PRIORITY_CLOSE: {
            return {
                ...state,
                addProjectCostPriorityState: false,
                editProjectCostPriorityState: false,
            };
        }
        case ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let projectCostPriorityList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    projectCostPriorityList = state.allProjectCostPriority;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    projectCostPriorityList = state.allProjectCostPriority.filter((projectCostPriority) => projectCostPriority.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, projectCostPriorityList, drawerState: false
            };
        }
        case ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                projectCostPriorityList: addOrUpdateEntry(state.projectCostPriorityList, action.payload),
                allProjectCostPriority: addOrUpdateEntry(state.allProjectCostPriority, action.payload),
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allProjectCostPriority: state.allProjectCostPriority.filter((projectCostPriority) => projectCostPriority.id !== action.payload),
                projectCostPriorityList: state.allProjectCostPriority.filter((projectCostPriority) => projectCostPriority.id !== action.payload),
            };
        }
        case ON_FILTER_SELECTED_PROJECT_COST_PRIORITY: {
            const projectCostPrioritys = state.allProjectCostPriority.filter((projectCostPriority) => !projectCostPriority.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                projectCostPriorityList: projectCostPrioritys,
                selectedProjectCostPrioritys: 0
            };
        }
        case FILTER_PROJECT_COST_PRIORITY: {
            const { filterOption } = state;
            let projectCostPriorityList = [];
            if (action.payload === '') {
                projectCostPriorityList = state.allProjectCostPriority;
            } else {
                const filterProjectCostPriority = state.allProjectCostPriority.filter((projectCostPriority) =>
                    projectCostPriority.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === ALL_FILTER) {
                    projectCostPriorityList = filterProjectCostPriority;
                } else if (filterOption === STARRED_FILTER) {
                    projectCostPriorityList = filterProjectCostPriority.filter((projectCostPriority) => projectCostPriority.starred);
                }
            }
            return { ...state, projectCostPriorityList: projectCostPriorityList };
        }
        case GET_ALL_PROJECT_COST_PRIORITY: {
            let projectCostPriorityList = state.allProjectCostPriority.map((projectCostPriority) => projectCostPriority ? {
                ...projectCostPriority,
                selected: true
            } : projectCostPriority);
            return {
                ...state,
                selectedProjectCostPrioritys: projectCostPriorityList.length,
                allProjectCostPriority: projectCostPriorityList,
                projectCostPriorityList: projectCostPriorityList
            };
        }
        case GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY: {
            let projectCostPriorityList = state.allProjectCostPriority.map((projectCostPriority) => projectCostPriority ? {
                ...projectCostPriority,
                selected: false
            } : projectCostPriority);
            return {
                ...state,
                selectedProjectCostPrioritys: 0,
                allProjectCostPriority: projectCostPriorityList,
                projectCostPriorityList: projectCostPriorityList
            };
        }
        case ON_ALL_PROJECT_COST_PRIORITY_SELECT: {
            const selectAll = state.selectedProjectCostPrioritys < state.projectCostPriorityList.length;
            let selectedProjectCostPrioritys = 0;
            let projectCostPriorityList = [];
            if (selectAll) {
                projectCostPriorityList = state.allProjectCostPriority.map((projectCostPriority) => projectCostPriority ? {
                    ...projectCostPriority,
                    selected: true
                } : projectCostPriority);
                selectedProjectCostPrioritys = projectCostPriorityList.length;
            } else {
                projectCostPriorityList = state.allProjectCostPriority.map((projectCostPriority) => projectCostPriority ? {
                    ...projectCostPriority,
                    selected: true
                } : projectCostPriority);
                selectedProjectCostPrioritys = 0;
            }
            return {
                ...state,
                selectedProjectCostPrioritys: selectedProjectCostPrioritys,
                allProjectCostPriority: projectCostPriorityList,
                projectCostPriorityList: projectCostPriorityList
            };
        }
        case UPDATE_SEARCH_PROJECT_COST_PRIORITY: {
            return { ...state, searchProjectCostPriority: action.payload };
        }
        case HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_PROJECT_COST_PRIORITY_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_PROJECT_COST_PRIORITY_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/projectCostPriority.js